import { Mail, Phone, Linkedin, MapPin } from "lucide-react";
import { LINKS } from "../../../data/content";

export const ContactSection = ({ t }) => {
  const rows = [
    { key: "EMAIL", value: LINKS.email, href: `mailto:${LINKS.email}`, Icon: Mail, testId: "contact-email" },
    { key: "PHONE", value: LINKS.phoneDisplay, href: `tel:${LINKS.phone.replace(/\s/g, "")}`, Icon: Phone, testId: "contact-phone" },
    { key: "LINKEDIN", value: "linkedin.com/in/ibrahim-şişman", href: LINKS.linkedin, external: true, Icon: Linkedin, testId: "contact-linkedin" },
    { key: "LOCATION", value: t.contact.location, Icon: MapPin, testId: "contact-location" },
  ];

  return (
    <div className="font-mono">
      <h2 className="text-2xl sm:text-3xl font-bold text-[var(--text)] max-w-3xl">
        <span className="text-[var(--cm)]"># </span>
        {t.contact.heading}
      </h2>
      <p className="mt-4 max-w-xl text-[13px] leading-relaxed text-[var(--muted)]">{t.contact.subtitle}</p>

      <div className="mt-10 border border-[var(--border)] bg-[var(--surface)] max-w-2xl">
        <div className="px-4 py-2.5 border-b border-[var(--border)] text-[10px] tracking-widest text-[var(--muted)]">
          .env
        </div>
        <div className="p-4 space-y-1 text-[13px]">
          {rows.map(({ key, value, href, external, Icon, testId }) => {
            const inner = (
              <>
                <Icon size={13} className="text-[#FF5722] shrink-0" />
                <span className="text-[var(--var)]">{key}</span>
                <span className="text-[var(--muted)]">=</span>
                <span className="text-[var(--str)] break-all group-hover:text-[#FF5722] transition-colors">
                  "{value}"
                </span>
              </>
            );
            return href ? (
              <a
                key={testId}
                data-testid={testId}
                href={href}
                target={external ? "_blank" : undefined}
                rel={external ? "noopener noreferrer" : undefined}
                className="flex items-center gap-2.5 py-1.5 px-2 -mx-2 hover:bg-[var(--line-hover)] transition-colors group"
              >
                {inner}
              </a>
            ) : (
              <div key={testId} data-testid={testId} className="flex items-center gap-2.5 py-1.5 px-2 -mx-2">
                {inner}
              </div>
            );
          })}
        </div>
      </div>

      <footer data-testid="footer" className="mt-16 pt-6 border-t border-[var(--border)] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[11px] text-[var(--cm)]">
        <span>{"// "}© {new Date().getFullYear()} — {t.contact.footer}</span>
        <span>{"// "}İstanbul, TR — vibe coded with ❤</span>
      </footer>
    </div>
  );
};
